var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNaviApi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.856,
    height: 30,
    viewBox: "0 0 496.856 511",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "api-svgrepo-com",
    transform: "translate(-7.071)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2873",
    "data-name": "Path 2873",
    d: "M492.168,309.579,474.542,299.4a220.409,220.409,0,0,0,.074-87.848l17.552-10.134a23.5,23.5,0,0,0,8.6-32.1l-48-83.139a23.5,23.5,0,0,0-32.1-8.6L403.1,87.721A224.881,224.881,0,0,0,327,43.692V23.5A23.527,23.527,0,0,0,303.5,0h-96A23.527,23.527,0,0,0,184,23.5V43.693a224.889,224.889,0,0,0-76,44.088l-17.669-10.2a23.5,23.5,0,0,0-32.1,8.6l-48,83.139a23.5,23.5,0,0,0,8.6,32.1L36.457,211.6a220.434,220.434,0,0,0-.073,87.848L18.832,309.579a23.528,23.528,0,0,0-8.6,32.1l48,83.139a23.527,23.527,0,0,0,32.1,8.6L107.9,423.279a224.9,224.9,0,0,0,76.1,44.03V487.5A23.527,23.527,0,0,0,207.5,511h96A23.527,23.527,0,0,0,327,487.5V467.307a224.9,224.9,0,0,0,76-44.087l17.668,10.2a23.528,23.528,0,0,0,32.1-8.6l48-83.139A23.528,23.528,0,0,0,492.168,309.579Zm-4.389,24.6-48,83.138a8.508,8.508,0,0,1-11.611,3.111L405.776,407.5a7.5,7.5,0,0,0-8.842.989,209.487,209.487,0,0,1-79.653,46.2A7.5,7.5,0,0,0,312,461.854V487.5a8.51,8.51,0,0,1-8.5,8.5h-96a8.51,8.51,0,0,1-8.5-8.5V461.855a7.5,7.5,0,0,0-5.28-7.164,209.523,209.523,0,0,1-79.755-46.139,7.5,7.5,0,0,0-8.843-.99L82.832,420.43a8.509,8.509,0,0,1-11.611-3.111l-48-83.138a8.512,8.512,0,0,1,3.111-11.612L48.6,309.71a7.5,7.5,0,0,0,3.566-8.146,206.113,206.113,0,0,1,.077-92.086,7.5,7.5,0,0,0-3.566-8.145l-22.349-12.9a8.5,8.5,0,0,1-3.111-11.611l48-83.139a8.5,8.5,0,0,1,11.612-3.111L105.225,103.5a7.5,7.5,0,0,0,8.842-.989,209.494,209.494,0,0,1,79.653-46.2A7.5,7.5,0,0,0,199,49.145V23.5a8.51,8.51,0,0,1,8.5-8.5h96a8.51,8.51,0,0,1,8.5,8.5V49.145a7.5,7.5,0,0,0,5.28,7.164,209.512,209.512,0,0,1,79.755,46.139,7.5,7.5,0,0,0,8.843.99l22.29-12.869a8.5,8.5,0,0,1,11.612,3.111l48,83.139a8.5,8.5,0,0,1-3.111,11.611L462.4,201.289a7.5,7.5,0,0,0-3.566,8.146,206.113,206.113,0,0,1-.077,92.086,7.5,7.5,0,0,0,3.566,8.145l22.349,12.9A8.511,8.511,0,0,1,487.779,334.181Z",
    fill: "#113252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2874",
    "data-name": "Path 2874",
    d: "M255.5,104C171.962,104,104,171.963,104,255.5S171.962,407,255.5,407,407,339.037,407,255.5,339.038,104,255.5,104Zm0,288C180.234,392,119,330.766,119,255.5S180.234,119,255.5,119,392,180.234,392,255.5,330.766,392,255.5,392Z",
    fill: "#113252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2875",
    "data-name": "Path 2875",
    d: "M283.5,216h-28a7.5,7.5,0,0,0-7.5,7.5v64a7.5,7.5,0,0,0,15,0V271h20.5a27.5,27.5,0,0,0,0-55Zm0,40H263V231h20.5a12.5,12.5,0,0,1,0,25Z",
    fill: "#113252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2876",
    "data-name": "Path 2876",
    d: "M214.522,220.867A7.5,7.5,0,0,0,207.5,216h-8a7.5,7.5,0,0,0-7.022,4.867l-24,64a7.5,7.5,0,0,0,14.045,5.267L186.7,279h33.6l4.175,11.133a7.5,7.5,0,1,0,14.044-5.266ZM192.322,264,203.5,234.193,214.678,264Z",
    fill: "#113252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2877",
    "data-name": "Path 2877",
    d: "M327.5,216a7.5,7.5,0,0,0-7.5,7.5v64a7.5,7.5,0,0,0,15,0v-64A7.5,7.5,0,0,0,327.5,216Z",
    fill: "#113252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2878",
    "data-name": "Path 2878",
    d: "M309.152,87.3c5.2,1.659,10.394,3.586,15.421,5.726a7.5,7.5,0,1,0,5.875-13.8c-5.458-2.323-11.09-4.415-16.742-6.216A7.5,7.5,0,1,0,309.152,87.3Z",
    fill: "#113252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2879",
    "data-name": "Path 2879",
    d: "M100.45,339.9a7.5,7.5,0,1,0-13.168,7.184,192.171,192.171,0,0,0,10.239,16.677,7.5,7.5,0,1,0,12.365-8.491A177.213,177.213,0,0,1,100.45,339.9Z",
    fill: "#113252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2880",
    "data-name": "Path 2880",
    d: "M240.14,431.341A176.693,176.693,0,0,1,132.724,382.3a7.5,7.5,0,0,0-10.435,10.775,191.735,191.735,0,0,0,116.563,53.21q.328.029.652.028a7.5,7.5,0,0,0,.636-14.972Z",
    fill: "#113252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2881",
    "data-name": "Path 2881",
    d: "M363.425,97.287a7.5,7.5,0,0,0-8.464,12.384,176.726,176.726,0,0,1,70.972,99.776,7.5,7.5,0,0,0,14.483-3.9A191.729,191.729,0,0,0,363.425,97.287Z",
    fill: "#113252"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaviApi);
export default __webpack_public_path__ + "static/media/naviApi.5e7fd6537ec722debc2886e430ab5c12.svg";
export { ForwardRef as ReactComponent };